<template>
  <shell>
    <div class="lg:w-full container m-auto">
      <div class="w-full lg:w-1/2 m-auto relative px-2">
        <h2 class="text-2xl pb-4">Edit Spell</h2>

        <div v-if="['EMAIL', 'DONE_EMAIL', 'TODO_EMAIL'].indexOf(spellKind) !== -1">

          <div v-if="member.email_verified === false" class="px-4 py-2 mb-6 bg-red">
            <div class="bg-red text-white text-sm leading-normal">
              Please add an email on the <router-link class="text-white" to="/account">account page</router-link>. Once you verify your email you can create an email Spell. 
            </div>
          </div>
        </div>

        <div v-else-if="['SMS'].indexOf(spellKind) !== -1">

          <div v-if="member.phone_number_verified === false" class="px-4 py-2 mb-6 bg-red">
            <div class="bg-red text-white text-sm leading-normal">
              Please add your phone number on the <router-link class="text-white" to="/account">account page</router-link>. Once you verify your phone number you can create an the text reminder spell.
            </div>
          </div>
        </div>


        <div v-if="error" class="px-4 py-2 mb-4 bg-red-lightest">
          <t-text kind="DANGER">{{error}}</t-text>
        </div>

        <div v-if="editPig">
          <div class="pb-10">
            <div class="bg-black py-4 px-2 rounded">
              <query-name
                :fn="editPig.fn"
                :frequency="editPig.mode"
                :startDate="editPig.start_from"
              />
            </div>
          </div>

          <edit-spell
            v-model="editPig"
          />
        </div>

        <div class="flex justify-between items-center">
          <t-button danger @click="deleteHandler" class="bg-red">Delete Spell</t-button>
          <div class="flex items-center">
            <router-link class="ml-4 text-black no-underline" to="/spells">Cancel</router-link>
            
            <t-button class="ml-4" @click="handler">Edit Spell</t-button>
          </div>
        </div>
      </div>

    </div>
  </shell>
</template>

<script>
 import dlv from 'dlv';
 import {mapState} from 'vuex';
 import api from '@/api';
 import Shell from '@/components/Shell';
 import EditSpell from '@/components/EditSpell';
 import QueryName from '@/components/QueryName';

 export default {
   props: {
     id: {
       type: String,
       required: true
     }
   },

   components: {Shell, EditSpell, QueryName},

   data () {
     return {
       editPig: this.pig,
       error: '',
     }
   },

   created () {
     this.editPig = this.pig;
   },

   computed: {
     ...mapState({
       member: state => state.member,
       pigs: state => state.pigs
     }),

     pig() {
       if (this.pigs.scheduled.length) {
         return this.pigs.scheduled.find(p => p.id === this.id);
       } else {
         return undefined;
       }
     },

     spellKind() {
       if (typeof this.pig === 'undefined') {
         return undefined
       }
       return Object.keys(this.pig.fn.run)[0]
     }
   },

   methods: {
     async handler () {
       const {err} = await api.editPig(this.pig.id, this.editPig);

       if (err) {
         this.error = err.response.data;
         return
       }

       this.$router.push({name: 'spells'});

     },

     async deleteHandler () {
       if (confirm('Are you sure you want to delete this Spell?')) {
         const {err} = await api.deletePig(this.pig.id);

         if (err) {
           this.error = err.response.data;
           return;
         }

         this.$router.push({name: 'spells'});
       }
     }
   },

   watch: {
     pig(to, from) {
       if (to){
         this.editPig = to;
       }
     }
   }
 }
</script>
